import React, { Component } from "react";
import styles from "./controlGroups.module.scss";
import { withCompanyGroups } from "../../../shared/containers/containerCompanyGroups";
import { states } from "../../../reducers/queriesStates";
import { TextField } from "@mui/material";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import Preloader from "../../../shared/items/static/preloader";

class ControlCreateGroup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "",
    };
  }

  componentDidUpdate(prevProps) {
    const { createGroupDataState } = this.props;

    if (prevProps.createGroupDataState === states.REQUEST && createGroupDataState === states.READY) {
      this.setState({ title: "" });
    }
  }

  onCreateHandler() {
    const { onCreateGroup } = this.props;
    const { title } = this.state;

    onCreateGroup(title);
  }

  onChangeTitle(e) {
    this.setState({ title: e.target.value });
  }

  render() {
    const { createGroupDataState } = this.props;
    const { title } = this.state;

    return (
      <div className={styles.createGroupPanel}>
        {/*  {error !== null ? <div className={styles.addUserError}>{error}</div> : null} */}
        <TextField
          size="small"
          label="Наименование группы"
          inputProps={{ sx: { width: "600px" } }}
          variant="outlined"
          value={title}
          onChange={this.onChangeTitle.bind(this)}
        />

        <ButtonPrimary disabled={title === null || title === ""} handleClick={this.onCreateHandler.bind(this)} title="Создать" />

        {createGroupDataState === states.REQUEST ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Preloader />
          </div>
        ) : null}
      </div>
    );
  }
}

export default withCompanyGroups(ControlCreateGroup);
